import React from 'react';
import { IParticipant } from 'twain-sport-fe-mono/interfaces';
import { EMPTY_SPACE } from 'twain-sport-fe-mono/constants/textSymbols';
import { translationProvider } from 'twain-sport-fe-mono/store/translations';
import classes from './ParticipantInfo.module.scss';

interface IProps {
    participant: IParticipant;
}

export const ParticipantInfo: React.FC<IProps> = (props) => (
    <div className={classes.container}>
        #{props.participant.jerseyNumber}
        {EMPTY_SPACE}
        <span className={classes.nickname}>{props.participant.nickname}</span>
        {EMPTY_SPACE}({translationProvider.string('rank')}
        {EMPTY_SPACE}
        {props.participant.rank})
    </div>
);
